// 本地开发环境配置

// ============================================
// 环境切换说明：
// 1. 内网环境（默认）：直连 http://192.168.1.158
// 2. 线上环境：通过 /dev-api-online 代理到 https://schoolapi.basejy.com
//
// 切换方式：
// 在浏览器控制台执行：localStorage.setItem('DEV_API_ENV', 'online')
// 切换回内网：localStorage.setItem('DEV_API_ENV', 'local') 或 localStorage.removeItem('DEV_API_ENV')
// ============================================

const getApiEnv = () => {
  if (process.env.DEV_API_ENV === "local") return "local";
  if (process.env.DEV_API_ENV === "online") return "online";
  if (typeof window === "undefined") return "local";
  const savedEnv = window.localStorage.getItem("DEV_API_ENV");
  return savedEnv === "online" ? "online" : "local";
};

/** 开发时 devServer 可能在 8001 等端口，与硬编码 8000 不一致会导致跳转死循环或打错端口 */
const devAppOrigin = () =>
  typeof window !== "undefined"
    ? `${window.location.protocol}//${window.location.host}`
    : "http://localhost:8000";

const apiEnv = getApiEnv();

const localConfig = {
  SERVER_URL: "http://192.168.1.158", // 后端服务域名
  BASE_SALES_SERVER_URL: "http://ttfs.154basejy.com", // base-sales 网关（勿走智校 SERVER_URL）
  BASE_USER_BEHAVIOR_SERVER_URL: "http://192.168.1.154",
  DEPLOY_DIR: "/", // 项目部署的目录
  APP_URL: devAppOrigin(), // 本项目访问地址（随当前 devServer 端口变化）
  ACTIVITY_MARKET_ORIGIN: "http://127.0.0.1:3100",
  H5_STATIC_SERVER_URL: "https://tencent.dev-env.basejy.com", // h5页面访问地址
  WX_APPID: "wx99bc4493f44c706f", // 微信公众号appid
  WX_MP_APP_ID: "wx99bc4493f44c706f", // 微信公众号扫码登录使用
  SHOW_MAI_DIAN_LOG: true, // 是否打印埋点日志到浏览器控制台
  ALLOW_MOBILE_LOGIN_PAGE: true, // 是否打开手机登录页面
  JW_APP_URL: devAppOrigin(),
  JW_KUAIPK_APP_URL: "http://v5.dev.basejy.com/kuaipk",
  JW_KUAIJW_APP_URL: "http://v5.dev.basejy.com/jw-inland",
  JW_KUAIJK_APP_URL: "http://localhost:8001",
  JW_KUAIXK_APP_URL: "http://localhost:8001",
  JW_KUAIFB_APP_URL: "http://localhost:8001",
  JW_KUAICJ_APP_URL: "http://v5.dev.basejy.com/kuaicj",
  AI_CHATBOT_BASE_URL: "http://ttfs.154basejy.com/base-chatbot", // AI聊天服务地址（开发环境使用测试环境，本地调试需要-wsk后缀）
  AI_CUSTOMER_BASE_URL: "http://aicustomer.dev.basejy.com", // AI客服服务地址
  KUAI_JW_CONSULTATION_URL: "http://www.test.school.basejy.com/#/basejw/kuaijw-consultation",
};

const onlineConfig = {
  SERVER_URL: "/dev-api-online", // 后端服务域名（线上）
  BASE_SALES_SERVER_URL: "https://api.basejy.com", // base-sales 网关（勿走智校 SERVER_URL）
  BASE_USER_BEHAVIOR_SERVER_URL: "/dev-api-online",
  DEPLOY_DIR: "/", // 项目部署的目录
  APP_URL: devAppOrigin(), // 本项目访问地址（随当前 devServer 端口变化）
  H5_STATIC_SERVER_URL: "https://school.basejy.com", // h5页面访问地址
  WX_APPID: "wx99bc4493f44c706f", // 微信公众号appid
  WX_MP_APP_ID: "wxef1aa2457078e512", // 微信小程序appid
  SHOW_MAI_DIAN_LOG: true, // 是否打印埋点日志到浏览器控制台
  ALLOW_MOBILE_LOGIN_PAGE: true, // 是否打开手机登录页面
  JW_APP_URL: devAppOrigin(),
  JW_KUAIPK_APP_URL: "https://kuaipk.basejy.com/",
  JW_KUAIJW_APP_URL: "https://jw.basejy.com/",
  JW_KUAIJK_APP_URL: "http://localhost:8001",
  JW_KUAIXK_APP_URL: "http://localhost:8001",
  JW_KUAIFB_APP_URL: "http://localhost:8001",
  JW_KUAICJ_APP_URL: "https://kuaicj.basejy.com/",
  AI_CHATBOT_BASE_URL: "https://api.basejy.com/base-chatbot", // AI聊天服务地址（线上环境）
  KUAI_JW_CONSULTATION_URL: "https://bsjw.basejy.com/#/basejw/kuaijw-consultation",
};

const config = apiEnv === "online" ? onlineConfig : localConfig;

if (typeof window !== "undefined" && process.env.NODE_ENV === "development") {
  console.log(
    `%c当前API环境: ${apiEnv === "online" ? "线上环境" : "内网环境"}`,
    `color: ${apiEnv === "online" ? "#52c41a" : "#1890ff"}; font-weight: bold; font-size: 14px;`,
  );
  console.log(`%cAPI地址: ${config.SERVER_URL}`, "color: #666; font-size: 12px;");
  console.log(
    '%c切换方式: localStorage.setItem("DEV_API_ENV", "online") 或 "local"',
    "color: #999; font-size: 11px;",
  );
}

export default config;
